module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route sp-cart-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "shop-page padding-top-100 padding-bottom-100",
    staticStyle: {
      "background": "#2d3a4b"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card"
  }, [_c('h6', [_vm._v("About Me")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-map-pin"
  }), _vm._v(" "), _c('b', [_vm._v("Shipping Address: ")]), _vm._v(_vm._s(_vm.user.user_address)), _c('br'), _vm._v("\r\n                NIGERIA.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-envelope"
  }), _c('b', [_vm._v("Email: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:someone@example.com",
      "target": "_top"
    }
  }, [_vm._v(_vm._s(_vm.user.user_email))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card"
  }, [_vm._m(3), _vm._v(" "), _c('h6', [_vm._v("My Boards")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "points"
    }
  }, [_c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Pick Some Items")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card"
  }, [_c('h6', [_vm._v("My Sellpoints")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#559155"
    }
  }, [_vm._v("Here you go...")]), _vm._v(" "), (_vm.sellpoints) ? _c('ul', _vm._l((_vm.sellpoints), function(sp) {
    return _c('li', [_c('a', {
      attrs: {
        "href": sp.business_username
      }
    }, [_vm._v(_vm._s(sp.business_name))])])
  })) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "create"
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Create a Sellpoint")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card"
  }, [_c('h6', [_vm._v("My Orders")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "points"
    }
  }, [_c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Pick Some Items")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card sp-bp-interest-block"
  }, [_c('h6', [_vm._v("My Buypoint Interests")]), _vm._v(" "), _c('ul', _vm._l((_vm.user_business_interests), function(bp) {
    return _c('li', [_c('a', {
      attrs: {
        "href": 'tour/' + bp.business_interest_category_name
      }
    }, [_vm._v(_vm._s(bp.business_interest_category_name))])])
  })), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Update my Interesta")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "contact-info acn-card"
  }, [_c('h6', [_vm._v("Settings")]), _vm._v(" "), _vm._l((_vm.user), function(profile) {
    return _c('ul', [_vm._m(6, true), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _vm._m(9, true)])
  })], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon-call-end"
  }), _vm._v(" "), _c('b', [_vm._v("Phone: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("you can edit these details anytime")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Edit Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "pull-right",
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "pink"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Want to Buy Something?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-chart"
  }), _vm._v("Items Bought \r\n              ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-basket"
  }), _vm._v("In my Cart \r\n              ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-basket"
  }), _vm._v("I want to buy \r\n              ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-basket"
  }), _vm._v("Ordered \r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_c('i', {
    staticClass: "icon-basket"
  }), _vm._v("Your Orders Brief.")])]), _vm._v(" "), _c('li')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-lock"
  }), _c('b', [_vm._v("Forgot Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" "), _c('b', [_vm._v("Change Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), _c('b', [_vm._v("Make a Complaint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" "), _c('b', [_vm._v("Request Help")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2286696"}!./src/pages/Buypoint/Account/template.html
// module id = 294
// module chunks = 0